'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _understyle = require('understyle');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var line = function line() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.map(function (_ref, i) {
    var _ref2 = _slicedToArray(_ref, 2);

    var x = _ref2[0];
    var y = _ref2[1];
    return i === 0 ? 'M' + x + ' ' + y : x === 'z' ? 'z' : 'L' + x + ' ' + y;
  }).join(' ');
};

var Line = function Line(_ref3) {
  var path = _ref3.path;
  var _ref3$paths = _ref3.paths;
  var paths = _ref3$paths === undefined ? [] : _ref3$paths;
  var _ref3$size = _ref3.size;
  var size = _ref3$size === undefined ? 16 : _ref3$size;
  var _ref3$stroke = _ref3.stroke;
  var stroke = _ref3$stroke === undefined ? 'currentcolor' : _ref3$stroke;
  var _ref3$strokeWidth = _ref3.strokeWidth;
  var strokeWidth = _ref3$strokeWidth === undefined ? 3 : _ref3$strokeWidth;
  var style = _ref3.style;
  var m = _ref3.m;
  var mt = _ref3.mt;
  var mr = _ref3.mr;
  var mb = _ref3.mb;
  var ml = _ref3.ml;
  var mx = _ref3.mx;
  var my = _ref3.my;
  var debug = _ref3.debug;

  var props = _objectWithoutProperties(_ref3, ['path', 'paths', 'size', 'stroke', 'strokeWidth', 'style', 'm', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'debug']);

  var sx = _extends({
    display: 'inline-block',
    verticalAlign: 'middle',
    overflow: 'visible'
  }, (0, _understyle.margin)({
    m: m,
    mt: mt,
    mr: mr,
    mb: mb,
    ml: ml,
    mx: mx,
    my: my
  }), style);

  return _react2.default.createElement('svg', _extends({}, props, {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 16 16',
    width: size,
    height: size,
    fill: 'none',
    stroke: stroke,
    strokeWidth: strokeWidth,
    style: sx
  }), path && _react2.default.createElement('path', {
    d: line.apply(undefined, _toConsumableArray(path))
  }), paths.map(function (p, i) {
    return _react2.default.createElement('path', {
      key: i,
      d: line.apply(undefined, _toConsumableArray(p))
    });
  }), debug && _react2.default.createElement('g', {
    strokeWidth: 1 / 8,
    opacity: 1 / 2,
    stroke: 'magenta'
  }, _react2.default.createElement('path', {
    d: line([0, 0], [16, 0], [16, 16], [0, 16], ['z'])
  }), _react2.default.createElement('path', {
    d: line([8, 0], [8, 16])
  }), _react2.default.createElement('path', {
    d: line([0, 8], [16, 8])
  })));
};

exports.default = Line;